import { systemInfoConstants } from "./systemInfo.constants";
import { systemInfoService } from "./systemInfo.service";

export const systemInfoActions = {
    getSystemInfo,
};

function getSystemInfo() {
    return dispatch => Promise.resolve(
        systemInfoService.getSystemInfo()
            .then(
                systemInfo => dispatch(success(systemInfo.data.Data)),
            ).catch(
                error => {
                    dispatch(failure(error.Message));
                }));


};

function success(systemInfo) { return { type: systemInfoConstants.GET_SYSTEM_SUCCESS, systemInfo } }
function failure(error) { return { type: systemInfoConstants.GET_SYSTEM_FAILURE, error } }
